// Automatically generated
export const USE_SEGMENT_STATE_KEYS = [
  "defaultValue",
  "value",
  "onChange",
  "formatOptions",
  "placeholderDate",
] as const;
export const SEGMENT_STATE_KEYS = [
  "fieldValue",
  "setFieldValue",
  "segments",
  "dateFormatter",
  "increment",
  "decrement",
  "incrementPage",
  "decrementPage",
  "setSegment",
  "confirmPlaceholder",
  "baseId",
  "unstable_idCountRef",
  "setBaseId",
  "unstable_virtual",
  "rtl",
  "orientation",
  "items",
  "groups",
  "currentId",
  "loop",
  "wrap",
  "shift",
  "unstable_moves",
  "unstable_hasActiveWidget",
  "unstable_includesBaseElement",
  "registerItem",
  "unregisterItem",
  "registerGroup",
  "unregisterGroup",
  "move",
  "next",
  "previous",
  "up",
  "down",
  "first",
  "last",
  "sort",
  "unstable_setVirtual",
  "setRTL",
  "setOrientation",
  "setCurrentId",
  "setLoop",
  "setWrap",
  "setShift",
  "reset",
  "unstable_setIncludesBaseElement",
  "unstable_setHasActiveWidget",
] as const;
export const SEGMENT_KEYS = [
  ...SEGMENT_STATE_KEYS,
  "segment",
  "isDisabled",
  "isReadOnly",
  "isRequired",
] as const;
export const SEGMENT_FIELD_KEYS = SEGMENT_STATE_KEYS;
